import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5181f3d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group-label" }, "Informations", -1))
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "reservationID" }, "Réservation", -1))
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "value", "onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group-label" }, "Informations personnalisées", -1))
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Ajouter des produits", -1))
const _hoisted_10 = { class: "product_list" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("input", {
    style: {"display":"inline-block","width":"40px"},
    disabled: "",
    type: "test",
    value: "€"
  })
], -1))
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { style: {"margin-top":"15px"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Produit custom ")
const _hoisted_20 = { class: "form-row" }
const _hoisted_21 = ["for"]
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "form-row" }
const _hoisted_24 = ["for"]
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "form-row" }
const _hoisted_27 = ["for"]
const _hoisted_28 = ["id"]
const _hoisted_29 = { class: "form-row" }
const _hoisted_30 = ["for"]
const _hoisted_31 = ["id", "value", "onClick"]
const _hoisted_32 = { class: "form-row" }
const _hoisted_33 = ["for"]
const _hoisted_34 = ["id", "value", "onClick"]
const _hoisted_35 = { class: "form-row" }
const _hoisted_36 = ["for"]
const _hoisted_37 = ["id"]
const _hoisted_38 = { class: "form-row" }
const _hoisted_39 = ["for"]
const _hoisted_40 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JbSearchField = _resolveComponent("JbSearchField")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_JbButton = _resolveComponent("JbButton")!
  const _component_JbCard = _resolveComponent("JbCard")!
  const _component_JbForm = _resolveComponent("JbForm")!

  return (_openBlock(), _createBlock(_component_JbForm, {
    class: "jb-form",
    validation: _ctx.form,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_JbSearchField, {
          name: "reservation",
          options: _ctx.searchedReservationsList,
          placeholder: "Rechercher...",
          preselected: _ctx.preselectedReservation,
          onKeyUp: _ctx.searchReservations,
          modelValue: _ctx.form.reservationId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.reservationId) = $event))
        }, null, 8, ["options", "preselected", "onKeyUp", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", {
          for: 'date-'+_ctx.$.uid
        }, "Date", 8, _hoisted_5),
        _createVNode(_component_DatePicker, {
          class: "inline-block h-full",
          modelValue: _ctx.form.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.date) = $event))
        }, {
          default: _withCtx(({ inputValue, togglePopover }) => [
            _createElementVNode("input", {
              type: "text",
              id: 'date-'+_ctx.$.uid,
              name: "date",
              value: inputValue,
              onClick: ($event: any) => (togglePopover()),
              readonly: ""
            }, null, 8, _hoisted_6)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_JbCard, { theme: "input" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.custom_products, (listEntry, index) => {
                return (_openBlock(), _createElementBlock("div", { key: listEntry }, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      style: {"display":"inline-block"},
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((listEntry.name) = $event)
                    }, null, 8, _hoisted_11), [
                      [_vModelText, listEntry.name]
                    ])
                  ]),
                  _hoisted_12,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      style: {"display":"inline-block"},
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((listEntry.custom_text) = $event)
                    }, null, 8, _hoisted_13), [
                      [_vModelText, listEntry.custom_text]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      style: {"display":"inline-block","width":"80px"},
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((listEntry.price) = $event)
                    }, null, 8, _hoisted_14), [
                      [
                        _vModelText,
                        listEntry.price,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _hoisted_15,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      style: {"display":"inline-block","width":"60px"},
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((listEntry.quantity) = $event)
                    }, null, 8, _hoisted_16), [
                      [
                        _vModelText,
                        listEntry.quantity,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "error icon-only",
                      onClick: _withModifiers(($event: any) => (_ctx.removeCustomProductFromFormList(index)), ["stop"])
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "times" })
                    ], 8, _hoisted_17)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_JbButton, {
                "icon-left": "plus",
                display: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCustomProductToFormList(_ctx.index)))
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("label", {
          for: 'client-name-'+_ctx.$.uid
        }, "Nom du client", 8, _hoisted_21),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.client_name) = $event)),
            id: 'client-name-'+_ctx.$.uid,
            name: "client_name",
            placeholder: "Nom du client"
          }, null, 8, _hoisted_22), [
            [_vModelText, _ctx.form.client_name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", {
          for: 'client-email-'+_ctx.$.uid
        }, "Email du client", 8, _hoisted_24),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.client_email) = $event)),
            id: 'client-email-'+_ctx.$.uid,
            name: "client_email",
            placeholder: "Email du client"
          }, null, 8, _hoisted_25), [
            [_vModelText, _ctx.form.client_email]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("label", {
          for: 'client-phone-'+_ctx.$.uid
        }, "Téléphone du client", 8, _hoisted_27),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.client_phone) = $event)),
            id: 'client-phone-'+_ctx.$.uid,
            name: "client_phone",
            placeholder: "Téléphone du client"
          }, null, 8, _hoisted_28), [
            [_vModelText, _ctx.form.client_phone]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("label", {
          for: 'date-arrival-'+_ctx.$.uid
        }, "Date d'arrivée", 8, _hoisted_30),
        _createVNode(_component_DatePicker, {
          class: "inline-block h-full",
          modelValue: _ctx.form.client_arrival,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.client_arrival) = $event))
        }, {
          default: _withCtx(({ inputValue, togglePopover }) => [
            _createElementVNode("input", {
              type: "text",
              id: 'date-arrival-'+_ctx.$.uid,
              name: "date",
              value: inputValue,
              onClick: ($event: any) => (togglePopover()),
              readonly: ""
            }, null, 8, _hoisted_31)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("label", {
          for: 'date-departure-'+_ctx.$.uid
        }, "Date de départ", 8, _hoisted_33),
        _createVNode(_component_DatePicker, {
          class: "inline-block h-full",
          modelValue: _ctx.form.client_departure,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.client_departure) = $event))
        }, {
          default: _withCtx(({ inputValue, togglePopover }) => [
            _createElementVNode("input", {
              type: "text",
              id: 'date-departure-'+_ctx.$.uid,
              name: "date",
              value: inputValue,
              onClick: ($event: any) => (togglePopover()),
              readonly: ""
            }, null, 8, _hoisted_34)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("label", {
          for: 'paid-'+_ctx.$.uid
        }, "Somme déjà payée", 8, _hoisted_36),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.paid) = $event)),
            id: 'paid-'+_ctx.$.uid,
            name: "paid",
            placeholder: "Somme déjà payée"
          }, null, 8, _hoisted_37), [
            [
              _vModelText,
              _ctx.form.paid,
              void 0,
              { number: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("label", {
          for: 'due-'+_ctx.$.uid
        }, "Somme à payer", 8, _hoisted_39),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.due) = $event)),
            id: 'due-'+_ctx.$.uid,
            name: "due",
            placeholder: "Somme à payer"
          }, null, 8, _hoisted_40), [
            [
              _vModelText,
              _ctx.form.due,
              void 0,
              { number: true }
            ]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation"]))
}